import { DefaultResponseType } from '@mm/state/model/ChatbotModel';

const CATCH_ALL_ENGAGEMENRS_AUTORESPONDER = 'catch_all';
const DEFAULT_PAGE = 'default_page';
const IGNORE = 'ignore';
const NO_TYPING = 'no_typing';
const DEFAULT_PAGE_ONCE_PER_SESSION = 'default_page_once_per_session';
const ONCE_PER_SESSION = 'Once per Conversation';
const ALWAYS = 'To each Unanswered Question';

type CompinedResponseData = {
  id: number;
  type: DefaultResponseType;
  text: string;
  notes?: string;
};

const types = [
  CATCH_ALL_ENGAGEMENRS_AUTORESPONDER,
  DEFAULT_PAGE,
  IGNORE,
  NO_TYPING,
  DEFAULT_PAGE_ONCE_PER_SESSION,
];

const DEFAULT_RESPONSES: Record<string, string> = {
  default_page: ALWAYS,
  default_page_once_per_session: ONCE_PER_SESSION,
};

const texts = [
  'Respond to unanswered questions with an IG and FB Engagement Autoresponders',
  'Respond to unanswered questions with a default Dialogue',
  'Ignore unanswered questions',
  'Prevent users from typing free-form messages to your bot',
];

const notes = [
  '',
  '',
  'Requires at least one option be added to your Main Menu',
];

const combinedData = types.map((t, i) => [
  t,
  { id: i, type: t, text: texts[i], note: notes[i] },
]);

const noMatchResponsesMap = new Map(
  combinedData as [[string, CompinedResponseData]],
);

export { noMatchResponsesMap, DEFAULT_RESPONSES };
